// extracted by mini-css-extract-plugin
module.exports = {"component":"repeater-matrix-item_component_TbDSi","is-active":"repeater-matrix-item_is-active_krlbA"};